import fe_en from '../../constants/translations/frontend/en-US.json';
import fe_ja from '../../constants/translations/frontend/ja.json'; // ~50KB
import fe_zh from '../../constants/translations/frontend/zh-CN.json'; // ~50KB
import merge from 'lodash.merge'; // ~50KB
import rn_en from '../../constants/translations/react-native/en'; // ~10KB
import rn_ja from '../../constants/translations/react-native/ja'; // ~10KB
import rn_zh from '../../constants/translations/react-native/zh'; // ~10KB

const en = merge(rn_en, fe_en);
const zh = merge(rn_zh, fe_zh);
const ja = merge(rn_ja, fe_ja);

/**
 * TODO: currently loads all languages, should try fetch conditionally from backend instead.
 */
export default function fetchTranslations(locale) {
  if (locale.startsWith('zh')) {
    return zh;
  } else if (locale.startsWith('ja') || locale.startsWith('jp')) {
    return ja;
  }
  return en;
}



// WEBPACK FOOTER //
// ./app/actions/translations/fetchTranslations.js